import { COLORS } from "../../../styles/variables"

export const DrawerStyle = {
    width: 60,
    flexShrink: 0,
    [`& .MuiDrawer-paper`]: { 
        width: 60, 
        borderRight: `1px solid ${COLORS.LINK_WATER}`,
        boxSizing: 'border-box', 
        top: '61px',
        height: 'calc(100% - 61px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        '@media (min-width:1920px)': {
            left: 'calc((100vw - 1920px) / 2)',
        },
    },
}

export const BoxEvents = {
    marginTop: '32px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
    width: '100%',
}

export const BoxTools = {
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    gap: 3, 
    width: '100%',
}

export const BoxSettings = {
    marginBottom: '32px', 
    width: '100%',
}

export const IconButtonStyle = {
    width: '100%',
    borderRadius: '6px',
}
